module.exports = __webpack_public_path__ + "img/wallet-3-fill.5fce17f4.svg";